export const ASC = 'asc';
export const DESC = 'desc';
export const VALUATION_DATE_KEY = 'valuation_date';
export const VALUATION_FEE_KEY = 'valuation_fee';
export const COMPANY_NAME_KEY = 'company_name';
export const STATUS_KEY = 'status';
export const NOTES_KEY = 'notes';
export const OTHER_CONSULTANT_KEY = 'other_consultants';
export const ENGAGEMENT_MANAGER_KEY = 'engagement_manager';
export const DEAL_KEY = 'deal';
export const DEAL_DUE_KEY = 'deal_due';
export const DEAL_STAGE_KEY = 'deal_stage';
export const CREATED_AT_KEY = 'created_at';
export const CREATED_AT = 'Creation Date';
export const DEAL_NAME_KEY = 'deal_name';
export const DEAL_NAME = 'Deal Name';
// Financial fields
export const NET_VALUE_KEY = 'net_value';
export const SPLIT_KEY = 'split';
export const PAYMENT_1_KEY = 'payment_1';
export const PAY_1_DATE_KEY = 'pay_1_date';
export const PAYMENT_2_KEY = 'payment_2';
export const PAY_2_DATE_KEY = 'pay_2_date';
export const PAYMENT_3_KEY = 'payment_3';
export const PAY_3_DATE_KEY = 'pay_3_date';
export const REFUND_KEY = 'refund';
export const REFUND_DATE_KEY = 'refund_date';
export const DUE_KEY = 'due';
export const ADJUSTMENT_KEY = 'adjustment';
export const ADJUSTMENT_DATE_KEY = 'adjustment_date';
export const BAD_DEBT_KEY = 'bad_debt';
export const BAD_DEBT_DATE_KEY = 'bad_debt_date';
export const RENEWAL_RATE_KEY = 'renewal_rate';
export const SUPPORTING_DUE_DATE_KEY = 'supporting_due_date';

export const VALUATION_DATE = 'Valuation Date';
export const VALUATION_FEE = 'Valuation Fee';
export const COMPANY_NAME = 'Company Name';
export const STATUS = 'Status';
export const NOTES = 'Notes';
export const OTHER_CONSULTANT = 'Other Consultant';
export const ENGAGEMENT_MANAGER = 'Engagement Manager';
export const DEAL = 'Deal';
export const DEAL_DUE = 'Deal Due';
export const DEAL_STAGE = 'Deal Stage';
// Financial field labels
export const NET_VALUE = 'Net Value';
export const SPLIT = 'Split';
export const PAYMENT_1 = 'Payment 1';
export const PAY_1_DATE = 'Payment 1 Date';
export const PAYMENT_2 = 'Payment 2';
export const PAY_2_DATE = 'Payment 2 Date';
export const PAYMENT_3 = 'Payment 3';
export const PAY_3_DATE = 'Payment 3 Date';
export const REFUND = 'Refund';
export const REFUND_DATE = 'Refund Date';
export const DUE = 'Due';
export const ADJUSTMENT = 'Adjustment';
export const ADJUSTMENT_DATE = 'Adjustment Date';
export const BAD_DEBT = 'Bad Debt';
export const BAD_DEBT_DATE = 'Bad Debt Date';
export const RENEWAL_RATE = 'Renewal Rate';
export const SUPPORTING_DUE_DATE = 'Supporting Due Date';

export const TOGGLEABLE_COLUMNS = [
  STATUS_KEY,
  NOTES_KEY,
  VALUATION_DATE_KEY,
  CREATED_AT_KEY,
  VALUATION_FEE_KEY,
  DUE_KEY,
  DEAL_NAME_KEY,
  SUPPORTING_DUE_DATE_KEY,
  OTHER_CONSULTANT_KEY,
  ENGAGEMENT_MANAGER_KEY,
  DEAL_KEY,
  DEAL_STAGE_KEY,
  NET_VALUE_KEY,
  SPLIT_KEY,
  PAYMENT_1_KEY,
  PAY_1_DATE_KEY,
  PAYMENT_2_KEY,
  PAY_2_DATE_KEY,
  PAYMENT_3_KEY,
  PAY_3_DATE_KEY,
  REFUND_KEY,
  REFUND_DATE_KEY,
  ADJUSTMENT_KEY,
  ADJUSTMENT_DATE_KEY,
  BAD_DEBT_KEY,
  BAD_DEBT_DATE_KEY,
  RENEWAL_RATE_KEY,
];

// Financial fields that should be hidden by default (used for grouping in column toggler)
export const FINANCIAL_FIELDS_HIDDEN_BY_DEFAULT = [
  DEAL_DUE_KEY,
  NET_VALUE_KEY,
  SPLIT_KEY,
  PAYMENT_1_KEY,
  PAY_1_DATE_KEY,
  PAYMENT_2_KEY,
  PAY_2_DATE_KEY,
  PAYMENT_3_KEY,
  PAY_3_DATE_KEY,
  REFUND_KEY,
  REFUND_DATE_KEY,
  ADJUSTMENT_KEY,
  ADJUSTMENT_DATE_KEY,
  BAD_DEBT_KEY,
  BAD_DEBT_DATE_KEY,
  RENEWAL_RATE_KEY,
];

// All columns that should be hidden by default (includes financial fields + other columns like creation date)
export const COLUMNS_HIDDEN_BY_DEFAULT = [
  ...FINANCIAL_FIELDS_HIDDEN_BY_DEFAULT,
  CREATED_AT_KEY,
  SUPPORTING_DUE_DATE_KEY,
];

export const DEAL_PERMITTED_STAGES = [
  'In service',
  'AWAITING FINAL PAYMENT',
  'COMPLETE DEAL',
  'CANCELLED',
];

export const ATTIO_VALUATIONS_OBJECT_ID = 'a496da15-a860-4853-bc8b-bd5dffd53aa5';
export const ATTIO_STAGES_ATTRIBUTE_ID = 'be9efdc2-09bc-415e-ba19-e9f39db774d4';

export { AttioQueryKeys } from 'dashboard409a/common/types/commonTypes';
